import { render } from "./CustomField.vue?vue&type=template&id=7752e39f&scoped=true"
import script from "./CustomField.vue?vue&type=script&lang=js"
export * from "./CustomField.vue?vue&type=script&lang=js"

import "./customField.scss?vue&type=style&index=0&id=7752e39f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7752e39f"]])

export default __exports__